"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.US_STATE_SELECTOR = exports.STATE_OR_COUNTY_DATA_STANDARDS = exports.STATE_OR_COUNTY = exports.CA_PROVINCE_SELECTOR = void 0;
var _Input = _interopRequireDefault(require("../../elements/input/Input"));
var _Select = _interopRequireDefault(require("../../elements/select/Select"));
var _formatAddressFieldTitleCase = _interopRequireDefault(require("../normalizers/formatAddressFieldTitleCase"));
var _restrictInput = require("../normalizers/restrictInput");
var _regex = _interopRequireWildcard(require("../regex"));
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != _typeof(e) && "function" != typeof e) return { "default": e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n["default"] = e, t && t.set(e, n), n; }
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
var formValidationSelectStateRequired = 'Please select a state';
var formValidationSelectProvinceRequired = 'Please select a province';
var STATE_OR_COUNTY = exports.STATE_OR_COUNTY = {
  component: _Input["default"],
  type: 'text',
  name: 'countyStateOrProvince',
  id: 'countyStateOrProvince',
  label: 'County',
  required: true,
  maxLength: 35,
  regex: (0, _regex["default"])(_regex.asciiExtendedPattern),
  validationMessageKeys: {
    required: 'Please enter your county/province/state',
    maxLength: "Sorry, the state or county you've entered is longer than we can accept",
    regex: 'Please remove the invalid characters to continue'
  },
  normalize: _restrictInput.asciiExtendedOnly,
  autoComplete: 'address-level1'
};
var US_STATE_SELECTOR = exports.US_STATE_SELECTOR = {
  component: _Select["default"],
  name: 'countyStateOrProvince',
  id: 'countyStateOrProvince',
  label: 'State',
  options: [{
    value: '',
    label: 'Select a state'
  }],
  required: true,
  validationMessageKeys: {
    required: formValidationSelectStateRequired,
    notInOptions: formValidationSelectStateRequired
  },
  autoComplete: 'address-level1'
};
var CA_PROVINCE_SELECTOR = exports.CA_PROVINCE_SELECTOR = {
  component: _Select["default"],
  name: 'countyStateOrProvince',
  id: 'countyStateOrProvince',
  label: 'Province',
  options: [{
    value: '',
    label: 'Select a province'
  }],
  required: true,
  validationMessageKeys: {
    required: formValidationSelectProvinceRequired,
    notInOptions: formValidationSelectProvinceRequired
  },
  autoComplete: 'address-level1'
};
var STATE_OR_COUNTY_DATA_STANDARDS = exports.STATE_OR_COUNTY_DATA_STANDARDS = _objectSpread(_objectSpread({}, STATE_OR_COUNTY), {}, {
  normalize: _formatAddressFieldTitleCase["default"],
  maxLength: 75,
  required: false
});